import Shepherd from 'shepherd.js';

if($('.dashboard--overview').length){

    $('.replay-onboarding').show();
        
    if($(window).width() < 992){
        var attachTo = {
            element: '.dashboard-title-wrapper .dashboard-sidebar-toggle',
            on: 'bottom'
        }
    }else{
        var attachTo = {
            element: '.dashboard--sidebar .nav--dashboard ul',
            on: 'right'
        }
    }

    if($('.has-account').length){
    
        ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
            var data = {
                'page': 'dashboard-license'
            };
            axios.post("/api/v1/onboarding", data);
        }));
        
        const tour = new Shepherd.Tour({
            defaultStepOptions: {
                cancelIcon: {
                    enabled: true
                },
                classes: 'shepherd-container',
                scrollTo: { behavior: 'smooth', block: 'center' }
            },
            useModalOverlay: true
        });
        
        tour.addStep({
            title: 'Welcome to Leading Edge Only',
            text: "Thanks for purchasing a license with LEO. This guide will show you how to access important parts of the platform. You're currently on the dashboard this is the hub for your account where you can find and access all your different resources",
            buttons: [
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-1'
        });
        
        if($('.nav-option-challenges').length){
            tour.addStep({
                title: "Challenges",
                text: "If you're looking to add a new Challenge or access your existing Challenges so you can edit them or view applications you can use this link.",
                attachTo: {
                    element: '.nav-option-challenges',
                    on: 'right'
                },
                buttons: [
                    {
                        action() {
                            return this.back();
                        },
                        classes: 'btn btn--border',
                        text: 'Back'
                    },
                    {
                        action() {
                            return this.next();
                        },
                        classes: 'btn btn--secondary',
                        text: 'Next'
                    }
                ],
                id: 'step-2'
            });
        }
        
        tour.addStep({
            title: "Innovation Library",
            text: "If you're looking to add a new innovation library or look at your existing libraries you can use this link",
            attachTo: {
                element: '.nav-option-library',
                on: 'right'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-3'
        });
        
        tour.addStep({
            title: "Messaging",
            text: "If you want to directly message other users on the platform or view your existing messages you can click here.",
            attachTo: {
                element: '.nav-option-messages',
                on: 'right'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-3-1'
        });
        
        tour.addStep({
            title: 'Getting Notified',
            text: "Stay up to date with what is happening with your Challenges! Whenever you have a new notification, a dot will appear next to this icon. Clicking it will open up your notifications.",
            attachTo: {
                element: '.notification-toggle',
                on: 'bottom'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-4'
        });
        
        tour.addStep({
            title: 'How do I get back?',
            text: "Whenever you want to revisit your dashboard click your user icon here or hover over it and select the exact page you wish to visit from thr dropdown.",
            attachTo: {
                element: '.dashboard-tab',
                on: 'bottom'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-5'
        });
        
        tour.addStep({
            title: 'Get started',
            text: "Why dont you get started by clicking here to create your first Challenge",
            attachTo: {
                element: '.overview-card--add-resource--network',
                on: 'bottom'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.complete();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Finish'
                }
            ],
            id: 'step-6'
        });

        if($('.dashboard--overview').length && !$('.onboarding-dashboard-license').length){
            tour.start();
        }

        $('.replay-onboarding').click(function(){
            tour.start();
        });
    }else{
    
        ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
            var data = {
                'page': 'dashboard'
            };
            axios.post("/api/v1/onboarding", data);
        }));
        
        const tour = new Shepherd.Tour({
            defaultStepOptions: {
                cancelIcon: {
                    enabled: true
                },
                classes: 'shepherd-container',
                scrollTo: { behavior: 'smooth', block: 'center' }
            },
            useModalOverlay: true
        });
        
        tour.addStep({
            title: 'Welcome to your Dashboard',
            text: "Using the tiles on your dashboard you can quickly view your messages, add a new innovation or start a Challenge. Once you've added an innovation, you will start seeing suggestions of Challenges you could apply to.",
            buttons: [
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-1'
        });
        
        tour.addStep({
            title: "Where's my stuff?",
            text: 'This is your personalised area where you will be able to view your existing Innovations, Challenges, Articles, Challenge Applications and Universities. You can also edit your profile details and log out from here.',
            attachTo: attachTo,
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-2'
        });
        
        tour.addStep({
            title: 'Finding your way around',
            text: 'Using this dropdown toggle you can open the main menu which gives you quick access to all areas of the platform including Challenges, Innovations, Articles and many more.',
            attachTo: {
                element: '.nav.nav--primary',
                on: 'bottom'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-3'
        });
        
        tour.addStep({
            title: 'Getting Notified',
            text: "Stay up to date with what is happening with your LEO notifications! Whenever you have a new notification, a dot will appear next to this icon. Clicking it will open up your notifications.",
            attachTo: {
                element: '.notification-toggle',
                on: 'bottom'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-4'
        });
        
        tour.addStep({
            title: 'How do I get back?',
            text: "Whenever you want to revisit your dashboard, click on your user icon here.",
            attachTo: {
                element: '.dashboard-tab',
                on: 'bottom'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.complete();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Finish'
                }
            ],
            id: 'step-5'
        });

        if($('.dashboard--overview').length && !$('.onboarding-dashboard').length){
            tour.start();
        }

        $('.replay-onboarding').click(function(){
            tour.start();
        });
    }
}
